module.exports = __webpack_public_path__ + "img/1.e05c9fe3.png";